import templateHTML from "./signin.component.html?raw"
import styleCSS from "./signin.component.scss?raw"

import { SignInView } from "../../views/sign-in-view"
import { i18n } from "../../../internationalize/i18n.service"
import { OTPDiag } from "../../views/otp.view"
import { webFlowService } from '../../services/web-flow.service'
import { type SessionCreateResponse } from "../../models/session-create-response"
import type { AuthService } from "../../services/auth.service"

const DIALOG_AUTO_CLOSE_TIMEOUT = 2000
type HTMLFormPager = HTMLDivElement

export class SigninComponent extends HTMLElement {
  private signInView!: SignInView
  private otpDiagView!: OTPDiag
  private formPager!: HTMLFormPager
  private state = { otp: false }
  private _autoCloseIntervalID: number | null = null

  constructor(private authService: AuthService = window.tbwServices.authService) { super(); }

  connectedCallback() {
    this.attachShadow({ mode: 'open' })
    const container = document.createElement('div')
    container.innerHTML = templateHTML
    const template = container.querySelector('template')
    const style = document.createElement('style')
    style.textContent = styleCSS
    this.shadowRoot!.appendChild(style)
    this.shadowRoot!.appendChild(i18n.parse(template!.content as unknown as HTMLElement));
    this.formPager = this.shadowRoot!.querySelector("#form-pager")!
    // console.log(this.formPager)
    this.init()
  }

  set otp(value: boolean) {
    this.state.otp = value
    if (value) {
      // this.classList.add('otp')
      // this.signInView.element.hidden = true
      // this.formPager.classList.add('otp') 
      const emailSendContainer = this.shadowRoot!.querySelector("#sign-in-container") as HTMLElement
      if (emailSendContainer) { emailSendContainer.style.display = "none" }
      const otpCheckContainer = this.shadowRoot!.querySelector("#otp-send-container") as HTMLElement
      if (otpCheckContainer) { otpCheckContainer.style.display = "flex" }
    }
  }

  async init() {
    const showOTPDialog = (email: string) => {
      this.otp = true
      this.otpDiagView.open(email)
    }

    const onEmailSent = async (email: string, _existingUserResponse: boolean) => {
      showOTPDialog(email)
    }

    const onOTPConfirmed = async (_session: SessionCreateResponse) => {
      // @ts-ignore
      this._autoCloseIntervalID = setTimeout(function () {
        window.location.replace('/')
      }, DIALOG_AUTO_CLOSE_TIMEOUT)
    }

    this.signInView = new SignInView(this.shadowRoot as unknown as HTMLElement, onEmailSent)
    this.otpDiagView = new OTPDiag(this.shadowRoot as unknown as HTMLElement, onOTPConfirmed)

    const checkLoginState = async () => {
      await this.authService.checkAuth()
      const authenticated = this.authService.isAuthenticated
      if (authenticated) { webFlowService.onLogin(this.authService.profile) }
    }

    checkLoginState()
  }
}